import { COLLECTIONS } from '__constants__'
import { doc, updateDoc } from 'firebase/firestore'

import firestore from 'services/firebase/firestore'

const { USERS } = COLLECTIONS

/**
 * If the user's email verification status has changed, update the user's email verification status
in the database.
 * @returns None
 */
const updateEmailVerificationStatus = ({
  _id,
  sessionUserEmailVerified,
  dbUserEmailVerified,
  onError
}) => {
  const isEmailVerificationUpdated =
    sessionUserEmailVerified !== dbUserEmailVerified

  /* If the user has updated their email address, update the user's emailVerified field in the
  database. */
  isEmailVerificationUpdated &&
    updateDoc(doc(firestore, USERS, _id), {
      emailVerified: sessionUserEmailVerified
    }).catch((err) => {
      onError && onError(err)
    })
}

export default updateEmailVerificationStatus
